import { render, staticRenderFns } from "./LazyLoadingTablesScroll.vue?vue&type=template&id=1bacb26a"
import script from "./LazyLoadingTablesScroll.vue?vue&type=script&lang=js"
export * from "./LazyLoadingTablesScroll.vue?vue&type=script&lang=js"
import style0 from "./LazyLoadingTablesScroll.vue?vue&type=style&index=0&id=1bacb26a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports